import React, { useState, useEffect, createRef } from "react";
import { Route, Switch, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Navbar from "./components/Header";
import Home from "./components/Home";
import Signin from "./components/Home/Signin";
import Signup from "./components/Home/Signup";
import ForgotPassword from "./components/Home/ForgotPassword";
import Dashboard from "./components/Private/Dashboard/Dashboard";
import PrivateRoute from "./components/Private/PrivateRoute";
import Settings from "./components/Private/Dashboard/Settings";

function App() {
  const location = useLocation();
  const [navigationHeight, setNavigationHeight] = useState(undefined);
  const navigation = createRef();

  useEffect(() => {
    setNavigationHeight(() => {
      return navigation?.current?.offsetHeight;
    });
  }, [navigation, navigationHeight]);

  return (
    <>
      <AnimatePresence>
        <Switch location={location} key={location.key}>
          <Route
            exact
            path="/"
            render={() => (
              <>
                <Navbar navigation={navigation} />
                <Home containerMinHeight={navigationHeight} />
              </>
            )}
          />

          <Route
            path="/SignIn"
            render={() => (
              <>
                <Navbar navigation={navigation} />
                <Signin containerMinHeight={navigationHeight} />
              </>
            )}
          />

          <Route
            path="/SignUp"
            render={() => (
              <>
                <Navbar navigation={navigation} />
                <Signup containerMinHeight={navigationHeight} />
              </>
            )}
          />

          <Route
            path="/Fogot-Password"
            render={() => (
              <>
                <Navbar navigation={navigation} />
                <ForgotPassword containerMinHeight={navigationHeight} />
              </>
            )}
          />

          <PrivateRoute path="/Dashboard" component={Dashboard} />
          <PrivateRoute path="/Settings" component={Settings} />
        </Switch>
      </AnimatePresence>
    </>
  );
}

export default App;
